import { memo, useEffect, useCallback, useState } from "react";
import Form from "../components/Form.js";
import { useSnackbar } from "../utils/index.js";
import Spinner from "../components/Spinner.js";
import useSelectStyles from "../components/styles/Select.js";
import { Box, Typography } from "@mui/material";
import {
    getOrganization,
    updateOrganization,
} from "../api/index.js";


const Organization = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [fetchedOrganization, setFetchedOrganization] = useState({});

    const classes = useSelectStyles();
    const { success, error } = useSnackbar();

    const fetchData = useCallback(
        async () => {
            setIsLoading(true);
            try {
                const { success: scs, organization, message } = await getOrganization();
                if (scs) {
                    setFetchedOrganization(organization);
                } else {
                    error(message);
                }
            } catch (err) {
                error(err)
            }
            setIsLoading(false);
        }
    )
    useEffect(() => {
        fetchData();
    }, []);

    const organizationFormContent = [
        {
            customType: "input",
            id: "name",
            type: "text",
            placeholder: "Επωνυμία",
            required: true,
            value: fetchedOrganization.name,
            disabled: false,
        },
        {
            customType: "input",
            id: "address",
            type: "text",
            placeholder: "Διεύθυνση",
            value: fetchedOrganization.address,
            disabled: false,
        },
        {
            customType: "input",
            id: "city",
            type: "text",
            placeholder: "Πόλη",
            required: true,
            value: fetchedOrganization.city,
            disabled: false,
        },
        {
            customType: "input",
            id: "county",
            type: "text",
            placeholder: "Νομός",
            value: fetchedOrganization.county,
            disabled: false,
        },
        {
            customType: "input",
            id: "postalCode",
            type: "text",
            placeholder: "Ταχ. Κώδικας",
            value: fetchedOrganization.postalCode,
            disabled: false,
        },
        {
            customType: "input",
            id: "phoneNumber",
            type: "text",
            placeholder: "Τηλέφωνο",
            value: fetchedOrganization.phoneNumber,
            disabled: false,
        },
        {
            customType: "input",
            id: "cellPhone",
            type: "text",
            placeholder: "Κινητό Τηλέφωνο",
            value: fetchedOrganization.cellPhone,
            disabled: false,
        },
        {
            customType: "input",
            id: "fax",
            type: "text",
            placeholder: "Fax",
            value: fetchedOrganization.fax,
            disabled: false,
        },
        {
            customType: "dropdown",
            id: "breed",
            items: [
                { value: "Χίος", text: "Χίος" },
                { value: "Σέρρες", text: "Σέρρες" },
                { value: "Αίγες", text: "Αίγες" },
                { value: "Zaanen", text: "Zaanen" },
                { value: "Δαμασκού", text: "Δαμασκού" },
            ],
            placeholder: "Φυλή",
            defaultValue: fetchedOrganization.breed,
            required: true,
        },
        {
            customType: "button",
            id: "submit",
            type: "submit",
            text: "Ενημέρωση στοιχείων",
        },
    ]

    const handleFormSubmit = async (values) => {
        setIsLoading(true)
        const { success: scs, message } = await updateOrganization(fetchedOrganization._id, values);
        if (scs) {
            success(message);
            fetchData();
        } else {
            error(message);
        }
        setIsLoading(false);
    }
    return (
        <>
            <Spinner open={isLoading} />
            <Box className={classes.outerBox}>
                <Box container flexDirection="column" className={classes.innerBox}>
                    <Typography variant="h5" sx={{ margin: "1rem" }}>
                        Στοιχεία Συνεταιρισμού
                    </Typography>
                    <Form content={organizationFormContent} onSubmit={handleFormSubmit} />


                </Box>
            </Box>
        </>
    )
};

export default memo(Organization);
